import actionTypes from './actionTypes';

export const isTenantRequesting = () => ({
    type: actionTypes.TENANT_REQUEST
});

export const isTenantAccepted = () => ({
    type: actionTypes.TENANT_ACCEPT
});
